import React, {useState} from "react";
import styles from "./HelpInfoBox.module.scss";

const HelpInfoBox = ({ direction = "left", children, defaultDisplay = false}) => {

    const [showPopup, setShowPopup] = useState(defaultDisplay);
    const [display, setDisplay] = useState(defaultDisplay);

    const handleTriggerShowPopup = (e) => {
        e.stopPropagation();
        setShowPopup(!showPopup);
        if (showPopup) {
            setDisplay(false);
        }
    }

    return (
        <div className={[styles.HelpInfoBox, !display && styles.displayNone].join(' ')}>
            <div onClick={handleTriggerShowPopup} className={styles.circle}></div>
            {
                showPopup &&
                    <div className={`${styles.infoBox} ${(direction === "right") ? styles.rightDirection : styles.leftDirection}`}>
                        <div className={`${styles.header} d-flex align-items-center justify-content-between mb-2`}>
                            <div className={'d-flex'}>
                                <div className={'d-flex'}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95043C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z" stroke="#0A195C" stroke-width="1.5"/>
                                        <path d="M12 15.5V11.5" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <circle cx="12" cy="9" r="0.5" stroke="#0A195C" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div className={'d-flex align-items-center ml-2'}>
                                    Info
                                </div>
                            </div>
                            <div onClick={handleTriggerShowPopup} className={`${styles.closeBtn} d-flex`}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="14.25" y1="4.81066" x2="4.81066" y2="14.25" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M4.45001 4.44999L14.2076 14.2075" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                        </div>
                        { children }
                    </div>
            }
        </div>
    )
}

export default HelpInfoBox;